import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import { listOfDatesByDay } from 'utils/dates';

const useStyles = makeStyles({
  root: {
    width: '75%',
    position: 'absolute',
    right: 50,
    bottom: 10,

    '&.MuiSlider-marked': {
      marginBottom: 0
    },
    '& span.MuiSlider-markLabel': {
      top: '20px !important ',
      fontWeight: 'bold',
      color: '#263238'
    }
  },
  date: {
    position: 'absolute',
    bottom: 20,
    right: '40%',
    fontSize: 13,
    fontWeight: 'bold'
  }
});

const marks = [
  {
    value: 0,
    label: 'launch'
  },
  {
    value: listOfDatesByDay().length - 1,
    label: 'today'
  }
];

const SliderComponent = ({ handleChange }) => {
  const classes = useStyles();
  const [date, setDate] = useState(
    listOfDatesByDay()[listOfDatesByDay().length - 1]
  );

  function ValueLabelComponent({ children, open }) {
    return (
      <Tooltip
        arrow
        enterTouchDelay={0}
        open={open}
        placement="top"
        title={date}
        TransitionComponent={Zoom}>
        {children}
      </Tooltip>
    );
  }

  function valueLabelFormat(value) {
    setDate(listOfDatesByDay()[value]);
  }

  return (
    <Slider
      aria-label="test"
      aria-labelledby="discrete-slider"
      className={classes.root}
      defaultValue={listOfDatesByDay().length - 1}
      getAriaValueText={valueLabelFormat}
      marks={marks}
      max={listOfDatesByDay().length - 1}
      min={0}
      onChange={handleChange}
      step={1}
      ValueLabelComponent={ValueLabelComponent}
      valueLabelDisplay="auto"
    />
  );
};

export default SliderComponent;
